//i18n (src/i18n/i18n.js)
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importa le traduzioni
import enTranslations from './locales/en.json';
import itTranslations from './locales/it.json';

const resources = {
  en: {
    translation: enTranslations
  },
  it: {
    translation: itTranslations
  }
};

i18n
  // Rileva automaticamente la lingua del browser
  .use(LanguageDetector)
  // Passa l'istanza i18n a react-i18next
  .use(initReactI18next)
  // Inizializza i18next
  .init({
    resources,
    fallbackLng: 'en', // Lingua di default
    debug: false,
    
    compatibilityJSON: 'v3',

    interpolation: {
      escapeValue: false,
    },
    
    // Opzioni per il rilevamento della lingua
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    }
  });

export default i18n;